import { gql } from "@apollo/client";

export const GET_PROVEEDOR_DISTRIBUIDOR_BY_CODPOSTAL = gql`
query DistribuidoresByCodPostal($idCodigoPostal: Int!){
    distribuidoresByCodPostal(idCodigoPostal: $idCodigoPostal) {    
        idProveedorDistribuidor,
        codigoSAP,
        razonSocial,
        proveedorMetodoCobroBulto{
          precio
          fechaDesde
          fechaHasta
        }

        proveedorMetodoCobroKM{
          valor
          fechaDesde
          fechaHasta
        }

        proveedorMetodoCobroKilo{
          valor
          fechaDesde
          fechaHasta
        }
    }
  }
`;